module.exports = "/images/97b2eae5f3dc6eaab2591e21019248a7.svg";